import React from 'react';

type MenuItemProps = {
  iconSrc: string;
  label: string;
};

const MenuItem: React.FC<MenuItemProps> = ({ iconSrc, label }) => (
  <div className="flex gap-[12px] items-start px-[16px] py-[12px] rounded-[8px] w-full">
    <div className="relative shrink-0 w-[20px] h-[20px]">
      <img src={iconSrc} alt="" className="block max-w-none w-full h-full" aria-hidden="true" />
    </div>
    <div className="flex flex-1 items-center justify-between w-full">
      <p className="text-[#1e1e1e] text-[14px] leading-[1.4]">{label}</p>
      <div className="relative w-[16px] h-[16px] shrink-0">
        <img
          src="/figma_asset/Chevron right.svg"
          alt=""
          className="block max-w-none w-full h-full"
          aria-hidden="true"
        />
      </div>
    </div>
  </div>
);

export const SideMenu: React.FC = () => {
  return (
    <nav
      className="bg-white border border-[#d9d9d9] rounded-[8px] shadow-[0_4px_4px_-1px_rgba(12,12,13,0.1),0_4px_4px_-1px_rgba(12,12,13,0.05)] p-[8px] w-[240px] min-w-[200px]"
      aria-label="サイドメニュー"
      data-node-id="1080:25188"
    >
      <div className="px-[16px] pt-[8px] pb-[4px] w-full">
        <p className="text-[#1e1e1e] text-[16px] font-semibold leading-[1.4]">医療事務メニュー</p>
      </div>
      <div className="px-[16px] py-[8px] w-full">
        <div className="bg-[#d9d9d9] h-px w-full" />
      </div>
      <div className="w-full">
        <MenuItem iconSrc="/figma_asset/Clock.svg" label="予約一覧" />
        <MenuItem iconSrc="/figma_asset/Clipboard.svg" label="患者様名簿" />
        <MenuItem iconSrc="/figma_asset/Calendar.svg" label="診療予約枠" />
      </div>
      <div className="px-[16px] py-[8px] w-full">
        <div className="bg-[#d9d9d9] h-px w-full" />
      </div>
      <div className="w-full">
        <MenuItem iconSrc="/figma_asset/File text.svg" label="請求情報" />
        <MenuItem iconSrc="/figma_asset/Hard drive.svg" label="メーカー機器設定" />
        <MenuItem iconSrc="/figma_asset/Settings.svg" label="基本情報" />
      </div>
    </nav>
  );
};
